/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketordernotrefundableerror4Inputs */

const en_ticketordernotrefundableerror4 = /** @type {(inputs: Ticketordernotrefundableerror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only paid orders can be refunded.`)
};

const de_ticketordernotrefundableerror4 = /** @type {(inputs: Ticketordernotrefundableerror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur bezahlte Bestellungen lassen sich erstatten.`)
};

/**
* | output |
* | --- |
* | "Only paid orders can be refunded." |
*
* @param {Ticketordernotrefundableerror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketordernotrefundableerror4 = /** @type {((inputs?: Ticketordernotrefundableerror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketordernotrefundableerror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketordernotrefundableerror4(inputs)
	return de_ticketordernotrefundableerror4(inputs)
});
export { ticketordernotrefundableerror4 as "ticketOrderNotRefundableError" }